export class PermissionTransformer {
  static transform (obj) {
	let permission   = {}
	permission.id    = obj.id
	permission.name  = obj.attributes.name
	permission.notes = obj.attributes.notes
    return permission
  }
}



// WEBPACK FOOTER //
// ./src/helpers/permissions/permission.transformer.js